import { STATUSES } from "./constant";
import { Badge } from "ui/components/badge";

export const StatusDisplay = ({ status }) => {
  if (!status) {
    return;
  }

  return (
    <Badge className={STATUSES[status]?.className}>
      {STATUSES[status]?.label ?? status}
    </Badge>
  );
};
